<template>
  <qtm-dialog-card
    :title="`Bulk Apply ${entity.label}`"
    width="500"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <div class="mb-6">
      Apply {{ entity.label.toLowerCase() }} to the selected line items.
      You can still edit individual items later if needed.
    </div>
    <qtm-input-label :label="`${entity.label}`">
      <cost-code-select
        v-if="entity.value === 'cc'"
        v-model="selectItem"
        :cost-codes="entity.selections"
        force-select
      />
      <qtm-select
        v-if="entity.value === 'uom'"
        v-model="selectItem"
        item-title="description"
        item-value="code"
        hide-details
        placeholder="Select unit of measure"
        :items="entity.selections"
      />
      <equipment-select
        v-if="entity.value === 'equipment'"
        v-model="selectItem"
        :equipment="entity.selections"
        item-value="id"
        hide-details
        placeholder="Select equipment"
      />
    </qtm-input-label>
    <template v-slot:actions>
      <qtm-btn size="x-large" tertiary @click="$emit('update:model-value', false)">
        Cancel
      </qtm-btn>
      <qtm-btn :disabled="!selectItem" size="x-large" @click="apply">
        Apply
      </qtm-btn>
    </template>
  </qtm-dialog-card>
</template>

<script setup lang="ts">
import type { LineItem } from '@quotetome/materials-api'
import CostCodeSelect from '@/components/cost-codes/cost-code-select.vue'
import EquipmentSelect from '@/components/items/equipment-select.vue'

export interface BulkEntity {
  itemProperty: string
  label: string
  selections: any[]
  value: string
}

export interface Props {
  entity: BulkEntity
  items: LineItem[]
  selected: (number | string)[]
}

const props = defineProps<Props>()
const emit = defineEmits(['applied', 'update:model-value'])

const selectItem = ref<string | null>(null)

const apply = () => {
  props.items.filter(item => props.selected.includes(item.id)).forEach(item => {
    item[props.entity.itemProperty] = selectItem.value!
  })

  emit('applied')
  emit('update:model-value', false)
  selectItem.value = null
}
</script>
